import { render, staticRenderFns } from "./AccountantPurchasing.vue?vue&type=template&id=557f28b8&"
import script from "./AccountantPurchasing.vue?vue&type=script&lang=js&"
export * from "./AccountantPurchasing.vue?vue&type=script&lang=js&"
import style0 from "./AccountantPurchasing.vue?vue&type=style&index=0&id=557f28b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports